import { MARKETING_SUBJECT_PATTERN } from "@reflect/domain";

import { webStorage } from "../browserStorage";

/** Anonymous browser subject used to keep marketing experiments sticky. */
export const MARKETING_SUBJECT_STORAGE_KEY = "reflect.marketing.subject";

/**
 * Read or mint the bounded subject used by the public assignment procedure.
 *
 * Persistence is an optimisation, so unreachable storage yields `undefined`
 * rather than failing the marketing page.
 *
 * @returns the stored or newly minted subject, or `undefined` without storage.
 */
export function getMarketingSubject(): string | undefined {
  const local = webStorage("local");
  if (!local) return undefined;
  try {
    const existing = local.getItem(MARKETING_SUBJECT_STORAGE_KEY);
    if (MARKETING_SUBJECT_PATTERN.test(existing ?? "")) return existing ?? undefined;
    const created =
      typeof crypto.randomUUID === "function"
        ? crypto.randomUUID()
        : `${Date.now().toString(36)}-${Math.random().toString(36).slice(2)}`;
    local.setItem(MARKETING_SUBJECT_STORAGE_KEY, created);
    return created;
  } catch {
    return undefined;
  }
}
